import json2csv from 'json2csv';
import { Departments, Settings } from './systemVariables';
import { PayeeTypes } from './constants';

export function formatCurrency(num, isIsraeli, noCurrencySign, alwaysPositive = false) {
    if (!num) {
        return num === 0 ? `${noCurrencySign ? '' : isIsraeli ? '₪' : '$'}0.00` : '';
    }

    num = parseFloat(num).toFixed(2);
    var parts = num.toString().split(".");
    var dollarAmount = alwaysPositive ? Math.abs(parts[0]) : parts[0];
    return (noCurrencySign ? '' : isIsraeli ? '₪' : '$') + dollarAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (parts[1] ? "." + parts[1] : "");
}

export function stripCurrencyFormat(formattedNum) {
    return formattedNum ? parseInt(formattedNum.toString().replace(/[^0-9\.]/g, '')) : '';
}

export function formatDate(dateString) {
    return dateString ? new Date(dateString).toLocaleDateString() : '';
}

export function formatNumber(numString) {
    return numString ? numString.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
}

export function formatNumberStringForExcel(numString) {
    return numString ? '="' + numString + '"' : null;
}

export function toTitleCase(str) {
    return str ? str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1)) : str;
}

export function formatDateForInput(dateString) {
    let date = '';
    if (dateString) {
        date = dateString;
        if (dateString.toString().length > 10) {
            var d = new Date(new Date(dateString)),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;

            return [year, month, day].join('-');
        }
    }
    return date;
}

export function getStartDate() {
    const date = new Date();
    if (date.getDate() === 1) return new Date(date.getFullYear(), date.getMonth() - 1, 1);
    return new Date(date.getFullYear(), date.getMonth(), 1);
}

export function concatenateAddressLabel(address, isIsraeli) {
    if (!address) return '';

    if (isIsraeli) {
        let streetNumDisplay;
        if (address.streetNumber && address.apartment) streetNumDisplay = `${address.streetNumber}/${address.apartment}`;
        else {
            if (address.streetNumber) streetNumDisplay = address.streetNumber;
            else if (address.apartment) streetNumDisplay = `-/${address.apartment}`;
        }
        return `${address.street ? `${address.street} ` : ''}${streetNumDisplay ? `${streetNumDisplay}, ` : ''} ${address.city ? `${address.city}, ` : ''}${address.state ? `${address.state} ` : ''}${address.zip ? `${address.zip}, ` : ''}${address.country ? `${address.country}` : ''}`;
    }
    return `${address.streetNumber ? `${address.streetNumber} ` : ''}${address.street ? `${address.street}, ` : ''}${address.unitType ? `${address.unitType} ` : ''}${address.apartment ? `${address.apartment}, ` : ''}${address.city ? `${address.city}, ` : ''}${address.state ? `${address.state} ` : ''}${address.zip ? `${address.zip}, ` : ''}${address.country ? `${address.country}` : ''}`;
}

export function concatenateGeosuggestLabel(address, isIsraeli) {
    if (!address) return '';

    return isIsraeli ? `${address.street ? `${address.street} ` : ''}${address.streetNumber ? `${address.streetNumber}, ` : ''}${address.city ? `${address.city}, ` : ''}${address.state ? `${address.state} ` : ''}${address.zip ? `${address.zip}, ` : ''}${address.country ? `${address.country}` : ''}`
        : `${address.streetNumber ? `${address.streetNumber} ` : ''}${address.street ? `${address.street}, ` : ''}${address.city ? `${address.city}, ` : ''}${address.state ? `${address.state} ` : ''}${address.zip ? `${address.zip}, ` : ''}${address.country ? `${address.country}` : ''}`;
}

export function getOrgDisplayName(titleKey, orgName, isIsraeli) {
    const titles = isIsraeli ? Settings.recipientSettings.israelInstitutionTitles : Settings.recipientSettings.usInstitutionTitles;
    const title = (titles[titles.map(t => t.key).indexOf(titleKey)] || {}).value;
    return `${title ? title + ' ' : ''}${orgName}`;
}

export function getIndividualDisplayName(titleKey, firstName, lastName, isIsraeli) {
    const titles = isIsraeli ? Settings.recipientSettings.israelPersonTitles : Settings.recipientSettings.usPersonTitles;
    const title = (titles[titles.map(t => t.key).indexOf(titleKey)] || {}).value;
    return `${title ? title + ' ' : ''}${firstName} ${lastName}`;
}

export function formatBankInfoDisplay(bankNum, branchNum, accountNum, accountHolder) {
    return (bankNum || branchNum || accountNum || accountHolder)
        ? `${bankNum || '--'}/${branchNum || '---'}/${accountNum || '---------'}${accountHolder ? ` held by ${accountHolder}` : ''}` : '';
}

export function isVowel(char) {
    return char ? ['a', 'e', 'i', 'o', 'u'].indexOf(char.toLowerCase()) !== -1 : false;
}

export function isValidEmail(email) {
    return email ? /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email) : true;
}

export function validateFieldLength(length, value) {
    return value ? value.toString().trim().length >= length : true;
}

export function exportCSVFile(headers, data, fileTitle) {
    const csv = convertToCSV(headers, data);

    const fileName = fileTitle ? fileTitle + '.xls' : 'export.xls';
    //download
    downloadCSV(csv, fileName);
}

export function convertToCSV(headers, data) {
    const flattenedData = data.map(data => {
        for (var key in data) {
            if (data[key] instanceof Array) {
                data[key] = data[key].join(", ");
            }
        }
        return data;
    });

    return json2csv({ data: flattenedData, fields: headers, withBOM: true });
}

export function downloadCSV(csv, fileName) {
    var blob = new Blob([csv], { type: 'text/xls;charset=utf-8;' });
    if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, fileName);
    } else {
        var link = document.createElement("a");
        if (link.download !== undefined) { // feature detection
            // Browsers that support HTML5 download attribute
            var url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", fileName);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
}

export function isEmptyObj(o) {
    return Object.keys(o).every(function (x) {
        return o[x] === '' || o[x] === null;  // or just "return o[x];" for falsy values
    });
}

export function flattenObj(ob) {
    return Object.keys(ob).reduce(function (toReturn, k) {

        if (Object.prototype.toString.call(ob[k]) === '[object Date]') {
            toReturn[k] = ob[k].toString();
        }
        else if ((typeof ob[k]) === 'object' && ob[k]) {
            if (Object.keys(ob[k]).length === 0 && ob[k].constructor === Object) {
                toReturn[k] = '';
            } else {
                const flatObject = flattenObj(ob[k]);
                Object.keys(flatObject).forEach(function (k2) {
                    toReturn[k + '.' + k2] = flatObject[k2];
                });
            }

        }
        else {
            toReturn[k] = ob[k];
        }

        return toReturn;
    }, {});
}

export function arrayToObjMap(array, keys) {
    let objMap = {};
    if (array && array.length)
        array.forEach(val => objMap[val.key] = !keys ? val.value : val.key);
    return objMap;
};

export function deepEquals(a, b, sort = false) {
    if (a && b) {
        if (a instanceof Array && b instanceof Array)
            return (sort ? arraysEqual(a.sort(), b.sort()) : arraysEqual(a, b));
        if (a instanceof Object && b instanceof Object)
            return objectsEqual(a, b);
    }
    return a === b;
}

function arraysEqual(a, b) {
    if (a.length !== b.length)
        return false;
    for (var i = 0; i < a.length; i++)
        if (!deepEquals(a[i], b[i]))
            return false;
    return true;
}

function objectsEqual(a, b) {
    var aKeys = Object.getOwnPropertyNames(a);
    var bKeys = Object.getOwnPropertyNames(b);
    if (aKeys.length !== bKeys.length)
        return false;
    aKeys.sort();
    bKeys.sort();
    for (var i = 0; i < aKeys.length; i++)
        if (aKeys[i] !== bKeys[i]) // keys must be strings
            return false;
    return deepEquals(aKeys.map(k => a[k]), aKeys.map(k => b[k]));
}

export function includesObj(obj, array) {
    for (let i = 0; i < array.length; i++) {
        if (deepEquals(array[i], obj)) return true;
    }
    return false;
}


export function replaceValuesInObject(obj, toReplace, replacementValue) {
    Object.keys(obj).forEach(key => {
        if (toReplace(obj[key])) {
            obj[key] = replacementValue;
        } else if (obj[key]) {
            if (obj[key] instanceof Array) {
                obj[key].forEach(rec => replaceValuesInObject(rec, toReplace, replacementValue));
            } else if (obj[key] instanceof Object) {
                replaceValuesInObject(obj[key], toReplace, replacementValue);
            }
        }
    });
}

export function locationIsIsraeli(locations, locationId) {
    if (!locations || !locationId) return false;

    const location = locations[locations.map(loc => loc.groupId.toString()).indexOf(locationId.toString())];
    return location ? location.department === Departments.IL : false;
}

export function getLocationDepartment(locations, locationId) {
    if (!locations || !locationId) return false;

    const location = locations[locations.map(loc => loc.groupId.toString()).indexOf(locationId.toString())];
    return location ? location.department : '';
}

export function validateAddressLocation(locations, locationId, address) {
    if (!locations || !locationId || !address) return;

    const { city, state, country } = address;
    if (!city || !country)
        return true;
    else {
        const location = locations[locations.map(loc => loc.groupId.toString()).indexOf(locationId.toString())];

        if (!location)
            return true;

        if (address.country === "United States") {
            return includesObj({
                city,
                state,
                country
            }, [...location.members.map(m => ({ city: m.city, state: m.state, country: m.country }))])
        } else if (address.country === 'ישראל' && location.department === Departments.IL && location.members.length === 1 && !location.members[0].city) {
            return true;
        } else {
            return includesObj({ city, country }, [...location.members.map(m => ({ city: m.city, country: m.country }))]);
        }
    }
}

export function formatReferenceOptions(references) {
    return references ? references.map(ref => ({
        key: ref.referenceId,
        value: ref.displayName,
        displayValue: formatReferenceDisplay(ref)
    })) : [];
}

function formatReferenceDisplay(reference) {
    if (!reference) return;

    const refProperties = [
        reference.displayName, reference.addressDisplay || reference.phoneNumber || reference.secondPhoneNumber || reference.email
    ].filter(p => p);
    if (reference.displayName.search(/[\u0590-\u05FF]/) >= 0) refProperties.reverse(); //reverse order for Hebrew references

    return refProperties.join(' - ');
}

export function getObjectKeyByValue(obj, value) {
    return obj ? Object.keys(obj).find(i => obj[i] === value) : null
}

export function getApplicationPayee(paymentInfo, recipient) {
    if (!paymentInfo) return {};

    switch (paymentInfo.payTo) {
        case PayeeTypes.Recipient:
            return recipient || {};
        case PayeeTypes.ThirdParty:
            return paymentInfo.thirdParty || {};
        case PayeeTypes.TrustedPayee:
            return recipient.trustedPayee || {};
        default:
            return {};
    }
}


// WEBPACK FOOTER //
// ./src/lib/utils.js